// Mock data for the ETech website rebranding

export const brand = {
  name: 'ETech',
  logoText: 'ETECH',
  tagline: 'Il tuo eCommerce, senza complicazioni.',
};

export const stats = [
  { number: '50+', label: 'brand lanciati o gestiti in partnership diretta' },
  { number: '500k€+', label: 'investiti in campagne pubblicitarie negli ultimi 12 mesi, profittevolmente' },
  { number: '500k€+', label: 'di fatturato generato sui nostri progetti' },
];

export const heroImages = {
  homeHero: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxhbmFseXRpY3MlMjBkYXNoYm9hcmQlMjBsYXB0b3B8ZW58MHx8fHwxNzg4MTY4ODUyfDA&ixlib=rb-4.1.0&q=85',
  formazione: 'https://images.unsplash.com/photo-1586880244386-8b3e34c8382c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxzaG9waWZ5JTIwbW9iaWxlfGVufDB8fHx8MTc4ODE2NDYxM3ww&ixlib=rb-4.1.0&q=85',
  dashboard: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGFuYWx5dGljc3xlbnwwfHx8fDE3ODgxNjQ2MTN8MA&ixlib=rb-4.1.0&q=85',
  team1: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHx0ZWFtJTIwb2ZmaWNlfGVufDB8fHx8MTc4ODE2NDYxM3ww&ixlib=rb-4.1.0&q=85',
  team2: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHx0ZWFtJTIwb2ZmaWNlfGVufDB8fHx8MTc4ODE2NDYxM3ww&ixlib=rb-4.1.0&q=85',
  analytics: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFuYWx5dGljc3xlbnwwfHx8fDE3ODgxNjQ2MTN8MA&ixlib=rb-4.1.0&q=85',
  logistics1: 'https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzg4MTY0NjEzfDA&ixlib=rb-4.1.0&q=85',
  logistics2: 'https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2UlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzg4MTY0NjEzfDA&ixlib=rb-4.1.0&q=85',
  logistics3: 'https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  accounting1: 'https://images.unsplash.com/photo-1762427355235-dd22e5cb010c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxhY2NvdW50aW5nJTIwZGVza3xlbnwwfHx8fDE3ODgxNjQ2MTN8MA&ixlib=rb-4.1.0&q=85',
  accounting2: 'https://images.unsplash.com/photo-1762427354051-a9bdb181ae3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxhY2NvdW50aW5nJTIwZGVza3xlbnwwfHx8fDE3ODgxNjQ2MTN8MA&ixlib=rb-4.1.0&q=85',
  sustainable1: 'https://images.unsplash.com/photo-1700165644892-3dd6b67b25bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxzdXN0YWluYWJsZSUyMHBhY2thZ2luZ3xlbnwwfHx8fDE3ODgxNjQ2MTN8MA&ixlib=rb-4.1.0&q=85',
  sustainable2: 'https://images.unsplash.com/photo-1595246135406-803418233494?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxzdXN0YWluYWJsZSUyMHBhY2thZ2luZ3xlbnwwfHx8fDE3ODgxNjQ2MTN8MA&ixlib=rb-4.1.0&q=85',
  gas1: 'https://images.unsplash.com/photo-1664285831203-fc5687b44e2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxnYXMlMjBjeWxpbmRlcnN8ZW58MHx8fHwxNzg4MTY0NjE0fDA&ixlib=rb-4.1.0&q=85',
  gas2: 'https://images.unsplash.com/photo-1585960410426-86a4b41a34f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxnYXMlMjBjeWxpbmRlcnN8ZW58MHx8fHwxNzg4MTY0NjE0fDA&ixlib=rb-4.1.0&q=85',
};

export const collaborationLevels = [
  {
    id: 'advisory',
    label: 'Advisory',
    forWho: 'Hai già un team interno e vuoi solo una direzione strategica esterna',
    includes: 'Documento strategico, roadmap 90 giorni, check-in periodici',
  },
  {
    id: 'full',
    label: 'Temporary Management Full',
    forWho: 'Hai volumi e budget ma non un team marketing/ops strutturato',
    includes: 'Il nostro team entra e opera su marketing, ads, sito, logistica e amministrazione come un vero reparto interno',
    featured: true,
  },
  {
    id: 'growth',
    label: 'Growth Partnership',
    forWho: "Hai un'idea o un brand ad alto potenziale e cerchi un partner, non un fornitore",
    includes: 'Investiamo anche noi — tempo, competenze e in alcuni casi capitale — dividendo rischio e risultati',
  },
];

export const services6 = [
  {
    title: 'Marketing & Strategy',
    desc: 'Documento strategico, posizionamento, piano editoriale, KPI e roadmap trimestrale',
  },
  {
    title: 'Advertising & Media Buying',
    desc: 'Setup asset pubblicitari, gestione Meta Ads, espansione Google/TikTok Ads, sourcing UGC',
  },
  {
    title: 'Creative Production',
    desc: 'Ricerca competitor, produzione creative per ads, testing sistematico basato sui dati',
  },
  {
    title: 'Sito & Tech',
    desc: 'Creazione e restyling siti Shopify, CRO continuo, integrazioni CRM/email/gestionali',
  },
  {
    title: 'Operations & Logistica',
    desc: 'Onboarding logistico (contrassegno e non), scelta fulfillment, negoziazione corrieri, resi',
  },
  {
    title: 'Pocket Administration',
    desc: 'P.IVA, fatturazione elettronica, IVA intracomunitaria, reportistica e cash flow',
  },
];

export const otherServices = [
  'CRM & Retention: email/SMS marketing, recupero carrello, programmi fedeltà',
  'Data & BI Dashboard: KPI in tempo reale, spend, ROAS, marginalità netta',
  'Ecommerce Etico: percorso dedicato per brand impact-driven',
  'Formazione Shopify & Facebook Ads: per chi non è ancora pronto al Temporary Management',
  'Intermediazione e acquisizione: cessione, acquisto o trade di brand, ricerca investitori/partner',
];

export const processSteps = [
  { n: '01', title: 'Call conoscitiva', desc: 'Ci raccontiamo, capiamo se e come possiamo essere utili' },
  { n: '02', title: 'Audit', desc: 'Analizziamo sito, ads, logistica e marginalità del tuo business' },
  { n: '03', title: 'Proposta', desc: "Ti presentiamo il livello di collaborazione più adatto e un piano d'azione a 90 giorni" },
  { n: '04', title: 'Kick-off', desc: 'Il team dedicato entra operativamente nel tuo progetto' },
  { n: '05', title: 'Crescita continua', desc: 'Report mensili, review periodiche, ottimizzazione costante' },
];

export const pillars = [
  {
    title: 'Operator DNA, non solo consulenza',
    body: "Con oltre 7 anni di esperienza nel settore, abbiamo testato tutte le variabili del mondo online, dall'offerta alla struttura del sito e dei social, alla comunicazione, fino al posizionamento e alla fidelizzazione dei clienti. Non lo abbiamo fatto in teoria: lo abbiamo fatto in pratica, con i nostri brand, i nostri soldi e i nostri sforzi.",
  },
  {
    title: 'Il nostro team diventa il tuo team',
    body: 'Non ti lasciamo un documento con delle direttive da implementare autonomamente, e non limitiamo la nostra presenza a call periodiche di aggiornamento. Ci mettiamo al tuo fianco, analizzando il lavoro svolto e migliorandolo a quattro mani, insieme a te. Marketing, campagne, sito, amministrazione, approvvigionamento.',
  },
  {
    title: 'Skin in the game reale',
    body: 'Siamo talmente sicuri del nostro sistema che, quando un progetto ci sembra particolarmente interessante, siamo noi a finanziarlo. Dividiamo costi e profitti come se fossimo al tuo fianco in questa avventura, condividendo il rischio d\'impresa con te.',
  },
  {
    title: 'Full-stack sotto un solo tetto',
    body: "Tutte le agenzie offrono servizi frammentati: o i social, o le campagne, o un documento strategico. Con ETech puoi delegare tutta l'operatività della tua azienda e concentrarti solo sulla sua crescita.",
  },
];

export const caseStudies = [
  {
    slug: 'da-0-a-50k-in-4-mesi',
    title: 'Da 0 a 50k€/mese in 4 mesi: il caso Nordic Living',
    excerpt: 'Il lancio di un brand di home décor scandinavo partendo da zero, fino a raggiungere 50.000€ di fatturato mensile in soli 4 mesi.',
    image: 'https://images.unsplash.com/photo-1730818874996-dea4bddf5554?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxzaG9waWZ5JTIwbW9iaWxlfGVufDB8fHx8MTc4ODE2NDYxM3ww&ixlib=rb-4.1.0&q=85',
    metric: '+50k€/mese',
    time: '4 mesi',
    tag: 'Growth Partnership',
    startPoint: 'Un fondatore con un\'idea di brand di home décor ispirato al design scandinavo, un magazzino iniziale limitato e nessuna presenza online.',
    actions: [
      'Sviluppo completo store Shopify con custom theme e integrazione CRM',
      'Lanciate 24 creative Meta Ads diverse in 6 settimane con testing sistematico',
      'Setup logistico con corriere premium e gestione resi automatizzata',
      'Costruzione flow email marketing (welcome, carrello abbandonato, post-acquisto)',
    ],
    results: [
      { k: 'Fatturato mensile', v: '50.000€' },
      { k: 'ROAS medio', v: '3.4x' },
      { k: 'Ordini/mese', v: '650+' },
    ],
    testimonial: "“ETech non ci ha venduto un servizio, ha costruito il brand insieme a noi. Nessuno lo avrebbe fatto rischiando come loro.” — Founder, Nordic Living",
  },
  {
    slug: 'triplicato-roas-in-60-giorni',
    title: 'Come abbiamo triplicato il ROAS di Fitwear in 60 giorni',
    excerpt: 'Un brand di abbigliamento sportivo con budget ADV bruciato in campagne non profittevoli. In 60 giorni abbiamo ricostruito la strategia.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFuYWx5dGljc3xlbnwwfHx8fDE3ODgxNjQ2MTN8MA&ixlib=rb-4.1.0&q=85',
    metric: '3x ROAS',
    time: '60 giorni',
    tag: 'Temporary Management Full',
    startPoint: 'Un brand fitness con volumi già interessanti ma ROAS medio 1.1x, budget ADV che stava erodendo la marginalità netta.',
    actions: [
      'Audit completo account Meta Ads e ristrutturazione campagne per obiettivo funnel',
      'Nuova produzione creative UGC con 15 talent selezionati',
      'Espansione su Google Ads (Search + Performance Max)',
      'Setup dashboard BI per monitoraggio ROAS/CAC/LTV in tempo reale',
    ],
    results: [
      { k: 'ROAS', v: '3.3x (da 1.1x)' },
      { k: 'CAC', v: '-58%' },
      { k: 'Spend mensile', v: '80.000€' },
    ],
    testimonial: '“Sembrava impossibile, invece bastava avere il team giusto al posto giusto.” — CMO, Fitwear',
  },
  {
    slug: 'magazzino-in-tilt-a-24h',
    title: 'Bellavita: da magazzino in tilt a spedizioni in 24h, senza assumere nessuno',
    excerpt: 'Brand di skincare naturale con ordini che si accumulavano e resi ingestibili. Il turnaround operativo in 90 giorni.',
    image: 'https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzg4MTY0NjEzfDA&ixlib=rb-4.1.0&q=85',
    metric: '24h',
    time: '90 giorni',
    tag: 'Temporary Management Full',
    startPoint: 'Skincare brand con crescita rapida ma logistica gestita internamente al 100%. Spedizioni con ritardo di 5-7 giorni.',
    actions: [
      'Passaggio a fulfillment 3PL selezionato tra 4 preventivi con SLA garantiti',
      'Ristrutturazione codici prodotto ed etichettatura per automazione picking',
      'Setup portale resi self-service integrato in Shopify',
      'Rinegoziazione tariffe corriere con -22% sui costi di spedizione',
    ],
    results: [
      { k: 'Tempo evasione', v: '<24h' },
      { k: 'Costo/spedizione', v: '-22%' },
      { k: 'Tasso reso', v: '-35%' },
    ],
    testimonial: '“Non abbiamo assunto nessuno e ora dormo la notte.” — Founder, Bellavita',
  },
  {
    slug: 'lancio-brand-food-b2c',
    title: 'Lancio brand food B2C: 12.000 clienti nei primi 6 mesi',
    excerpt: "Dall'idea al mercato: come abbiamo portato online un brand di specialità gastronomiche italiane.",
    image: 'https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2UlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzg4MTY0NjEzfDA&ixlib=rb-4.1.0&q=85',
    metric: '12.000',
    time: '6 mesi',
    tag: 'Growth Partnership',
    startPoint: 'Un produttore artigianale con eccellenti materie prime ma zero canali diretti al consumatore.',
    actions: [
      "Ideazione brand e naming, guida stile, packaging e restyling completo",
      'Sviluppo store Shopify con configuratore box regalo',
      'Lancio con influencer food italiani e campagne Meta/TikTok',
      'Automazione fiscale e OSS per vendite intra-UE',
    ],
    results: [
      { k: 'Clienti unici', v: '12.000' },
      { k: 'AOV', v: '68€' },
      { k: 'Fatturato 6 mesi', v: '820k€' },
    ],
    testimonial: '“Loro capiscono che il prodotto viene prima del marketing. Ecco perché funziona.” — Fondatore',
  },
  {
    slug: 'crescita-brand-fashion-donna',
    title: 'Elysia: brand fashion donna, +180% ordini YoY',
    excerpt: 'Un brand fashion in stallo. Il rilancio con nuova strategia creative-first.',
    image: 'https://images.unsplash.com/photo-1586880244386-8b3e34c8382c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxzaG9waWZ5JTIwbW9iaWxlfGVufDB8fHx8MTc4ODE2NDYxM3ww&ixlib=rb-4.1.0&q=85',
    metric: '+180%',
    time: '12 mesi',
    tag: 'Advisory',
    startPoint: 'Un fashion brand con basi solide ma senza crescita da 18 mesi.',
    actions: [
      'Documento strategico e roadmap 90 giorni',
      "Ripositioning brand su target 28-40 con nuova identità visiva",
      'Setup programma fedeltà e retention email flows',
      'Check-in mensili con il team interno del cliente',
    ],
    results: [
      { k: 'Ordini YoY', v: '+180%' },
      { k: 'Retention 90gg', v: '38%' },
      { k: 'AOV', v: '+24%' },
    ],
    testimonial: "“Ci hanno dato la direzione. Il resto l'abbiamo fatto insieme.” — CEO, Elysia",
  },
  {
    slug: 'scaleup-integratori-multichannel',
    title: 'Vitalprime: scaleup multichannel per un brand di integratori',
    excerpt: 'Da singolo canale Amazon a strategia multichannel con D2C protagonista.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGFuYWx5dGljc3xlbnwwfHx8fDE3ODgxNjQ2MTN8MA&ixlib=rb-4.1.0&q=85',
    metric: '+340%',
    time: '9 mesi',
    tag: 'Temporary Management Full',
    startPoint: 'Brand integratori dipendente al 90% da Amazon. Marginalità sotto pressione.',
    actions: [
      'Lancio store D2C con logica subscription',
      'Split budget ADV multichannel e attribution modeling',
      'Setup logistica dedicata D2C con packaging brandizzato',
      'Programma referral con reward system',
    ],
    results: [
      { k: 'D2C su totale', v: '55%' },
      { k: 'Fatturato', v: '+340%' },
      { k: 'Marginalità netta', v: '+18pp' },
    ],
    testimonial: '“Non pensavamo fosse possibile ridurre così tanto la dipendenza da Amazon.” — Founder',
  },
];

export const menuStructure = [
  { label: 'Home', path: '/' },
  { label: 'Casi Studio', path: '/casi-studio' },
  {
    label: 'Temporary Management',
    path: '/temporary-management',
    children: [
      { label: "Perché non siamo un'agenzia", path: '/temporary-management#perche-agenzia' },
      { label: 'Come lavoriamo', path: '/temporary-management#come-lavoriamo' },
      { label: 'Livelli di collaborazione', path: '/temporary-management#livelli' },
      { label: 'Cosa facciamo', path: '/temporary-management#servizi' },
    ],
  },
  {
    label: 'Chi Siamo',
    path: '/chi-siamo',
    children: [
      { label: 'Chi Siamo', path: '/chi-siamo' },
      { label: 'Ecommerce Etico', path: '/ecommerce-etico' },
      { label: 'E-gas', path: '/e-gas' },
    ],
  },
  {
    label: 'Servizi eCommerce',
    path: '/sviluppo-brand',
    children: [
      { label: 'Sviluppo Brand', path: '/sviluppo-brand' },
      { label: 'Pocket Administration', path: '/pocket-administration' },
    ],
  },
  { label: 'Contatti', path: '/contatti' },
];
